import { render, staticRenderFns } from "./platformType.vue?vue&type=template&id=65dc47c6&scoped=true"
import script from "./platformType.vue?vue&type=script&lang=js"
export * from "./platformType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc47c6",
  null
  
)

export default component.exports